import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  timeline: {
    position: 'relative',
    maxWidth: 952,
    margin: `${theme.spacing(4)} auto`,
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(5),
    },
  },
  midLine: {
    position: 'absolute',
    left: '50%',
    top: 0,
    width: 1,
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.14)',
    [theme.breakpoints.down('md')]: {
      left: 30,
    },
  },
  mainIcon: {
    opacity: 1,
  },
  item: {
    position: 'relative',
    padding: theme.spacing(3, 6, 2, 6),
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      paddingBottom: theme.spacing(8),
    },
    [theme.breakpoints.up('md')]: {
      width: '50%',
    },
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(-4),
    },
    '&:nth-of-type(2n)': {
      [theme.breakpoints.up('md')]: {
        marginLeft: '50%',
      },
      '& .item-icon': {
        [theme.breakpoints.up('md')]: {
          left: -24,
        },
      },
    },
    '&:nth-of-type(2n + 1)': {
      [theme.breakpoints.up('md')]: {
        marginRight: '50%',
        textAlign: 'right',
      },
      '& .item-icon': {
        [theme.breakpoints.up('md')]: {
          right: -24,
        },
      },
    },
  },
  itemIcon: {
    height: 48,
    width: 48,
    position: 'absolute',
    top: 9,
    backgroundColor: '#FFF',
    borderRadius: '100%',
    '&.no-border': {
      border: 'unset',
    },
    '& > *': {
      color: theme.palette.grey[400],
      width: 24,
      height: 24,
      margin: 13,
      padding: 0,
    },
    [theme.breakpoints.down('md')]: {
      left: -24,
    },
  },
  itemContent: {
    opacity: 1,
  },
  newItem: {
    background: 'rgba(0, 0, 0, 0.04)',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    padding: theme.spacing(2),
    marginTop: theme.spacing(-2),
  },
  error: {
    color: 'rgb(244, 67, 54)',
    marginTop: theme.spacing(2),
  },
  addContent: {
    marginTop: theme.spacing(2),
  },
  itemYears: {
    textTransform: 'uppercase',
    marginTop: theme.spacing(1),
  },
  itemHighlights: {
    marginTop: theme.spacing(1),
    '& ul': {
      textAlign: 'left',
    },
    '& ol': {
      textAlign: 'left',
    },
    '& pre': {
      whiteSpace: 'normal',
    },
  },
}))
